import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconListBulleted = ({ size = 18, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M9 6h12M9 12h12M9 18h12' />
      <circle cx='4' cy='6' r='1' fill='currentColor' />
      <circle cx='4' cy='12' r='1' fill='currentColor' />
      <circle cx='4' cy='18' r='1' fill='currentColor' />
    </g>
  </SDIcon>
)

export default IconListBulleted
